module.exports = __webpack_public_path__ + "static/media/Distortion (Dumble clean) VR.4acbacf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/pedal/Distortion (Dumble clean) VR.mp3
// module id = nLFL
// module chunks = 12